// React Query keys for the Fresh packing station (under ['shop', id] so shop-wide invalidation reaches them).
export const freshKeys = {
  weigh: (shopId: string) => ['shop', shopId, 'fresh', 'weigh'] as const,
  arrivals: (shopId: string, since: string) => ['shop', shopId, 'fresh', 'arrivals', since] as const,
};
